<template>
    <b-modal
        id="editStudentGroups"
        title="Editar Turma(s) do Aluno"
        centered
        hide-footer
    >
        <b-overlay :show="loading" rounded="sm">

            <!-- Field -->
            <b-form-group
                label="Aluno">
                <b-input v-model="form.student_name" disabled />
            </b-form-group>

            <!-- Field -->
            <b-form-group
                label="Turma(s)"
                description="Qual a(s) turma(s) que seu aluno irá participar ?">

                <multiselect
                    v-model="form.groups"
                    :options="groupsOptions"
                    :taggable="true"
                    :multiple="true"
                    :loading="loading"
                    track-by="id"
                    label="name"
                    placeholder="Buscar por Turma ..."
                    tag-placeholder="Filtrar Turma"
                    selectLabel="Selecionar"
                    deselectLabel="Desmarcar"
                    selectedLabel="Selecionado">

                        <span slot="noResult">
                            Ops! Nenhum resultado encontrado na pesquisa :(
                        </span>

                        <span slot="noOptions">
                            Não há turmas disponíveis para exibir :(
                        </span>

                </multiselect>
            </b-form-group>

            <b-form-group>

                <b-button type="button" variant="primary" @click="update" :disabled="loading">
                    Editar Turma(s)
                </b-button>
            </b-form-group>
        </b-overlay>
    </b-modal>
</template>

<script>
export default {
    props: ['groupsOptions'],
    data() {
        return {
            loading: false,
            id: null,
            form: {
                student_name: null,
                groups: null,
            },
        }
    },
    created() {

        this.$root.$on('updateStudentGroups', (student) => {

            this.id = student.id
            this.form.student_name = student.name
            this.form.groups = student.groups

            this.$bvModal.show('editStudentGroups')
        })

    },
    methods: {

        update() {
            this.loading = true;
            axios.put('/teacher/students/' + this.id + '/groups', {
                ...this.form,
                groups: this.form.groups.map(element => (element.id))
            })
                .then((result) => {

                    // Load
                    this.$emit('updated')

                    // Message
                    this.$toast.success('Turma(s) atualizada(s) com sucesso :)');

                    // Close Modal
                    this.$bvModal.hide('editStudentGroups')

                })
                .finally(() => this.loading = false)
        },
    }
}
</script>

<style scoped>

</style>
